function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(234, 231, 231)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'sage': 'rgb(114, 140, 105)','metallic-gold': 'rgb(212, 175, 55)','antique-gold': 'rgb(180, 139, 91)','light-copper': 'rgb(231, 164, 103)','metallic-silver': 'rgb(211, 211, 211)','metallic-light-gold': 'rgb(241, 212, 117)','metallic-pale-gold': 'rgb(239, 235, 202)','peach': 'rgb(245, 186, 129)','coral': 'rgb(254, 125, 106)','eggshell': 'rgb(241, 230, 214)','fuchsia': 'rgb(255, 9, 97)','ash-blue': 'rgb(228, 239, 238)','mist': 'rgb(222, 223, 217)','forest': 'rgb(62, 89, 67)','slate': 'rgb(151, 162, 180)','mint': 'rgb(193, 249, 199)','fairy': 'rgb(247, 231, 225)','deep-magenta': 'rgb(137, 47, 99)','willow': 'rgb(199, 221, 203)','emerald': 'rgb(36, 87, 21)','mauve-rose': '',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
